import React from 'react';

const useHover = () => {
  const [isHovering, setHovering] = React.useState(false);

  const handleMouseEnter = React.useCallback(() => {
    setHovering(true);
  }, [setHovering]);

  const handleMouseLeave = React.useCallback(() => {
    setHovering(false);
  }, [setHovering]);

  return React.useMemo(
    () => ({
      isHovering,
      handlers: {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
      },
    }),
    [isHovering, handleMouseEnter, handleMouseLeave],
  );
};

export default useHover;
